module.exports = __webpack_public_path__ + "img/b1.3a995838.jpg";